import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from '../../../../../services/nav.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-horizontal-nav-item',
  imports: [CommonModule, MatIconModule],
  templateUrl: './nav-item.component.html',
})
export class AppHorizontalNavItemComponent implements OnInit {
  @Input() depth: any;
  @Input() item: any;

  constructor(public navService: NavService, public router: Router) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnInit() {}

  getExternalHref(route: string): string {
    if (!route) return '/';
    if (/^https?:\/\//i.test(route)) return route;

    const path = route.startsWith('/') ? route : `/${route}`;
    if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
      return `http://localhost:8184${path}`;
    }
    return path;
  }

  onItemSelected(item: any) {
    if (item.external) {
      window.location.href = this.getExternalHref(item.route);
      return;
    }
    if (!item.children || !item.children.length) {
      this.router.navigate([item.route]);
    }
  }
}
